import { gql } from '@apollo/client';

export const ASSESSMENT_STAGE_FIELDS = gql`
  fragment AssessmentStageFields on AssessmentStage {
    _id
    order
    type
    title
    config
    isCompleted
    isInProgress
  }
`;

export const COMPLETE_ASSESSMENT_STAGE = gql`
  mutation CompleteAssessmentStage($_id: ID!) {
    completeAssessmentStage(_id: $_id) {
      ...AssessmentStageFields
    }
  }

  ${ASSESSMENT_STAGE_FIELDS}
`;

export const CREATE_ASSESSMENT_STAGE = gql`
  mutation CreateAssessmentStage($data: CreateAssessmentStageInput!) {
    createAssessmentStage(data: $data) {
      ...AssessmentStageFields
    }
  }

  ${ASSESSMENT_STAGE_FIELDS}
`;

export const UPDATE_ASSESSMENT_STAGE = gql`
  mutation UpdateAssessmentStage($_id: ID!, $data: UpdateAssessmentStageInput!) {
    updateAssessmentStage(_id: $_id, data: $data) {
      ...AssessmentStageFields
    }
  }

  ${ASSESSMENT_STAGE_FIELDS}
`;

export const REMOVE_ASSESSMENT_STAGE = gql`
  mutation RemoveAssessmentStage($_id: ID!) {
    removeAssessmentStage(_id: $_id) {
      _id
    }
  }
`;

export const MOVE_ASSESSMENT_STAGE = gql`
  mutation MoveAssessmentStage($_id: ID!, $direction: AssessmentStageMoveDirection!, $expectedOrder: Int!) {
    moveAssessmentStage(_id: $_id, direction: $direction, expectedOrder: $expectedOrder) {
      _id
    }
  }
`;
